const prepaidInventoryPersonalizedTabStyle = {

};

export default prepaidInventoryPersonalizedTabStyle;
